import http from './http.service';

class DataReferencesService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/dataReferences";
    }

    loadReplacementHistory(schemaName, tableName, entityId) {
        return this.$http.get(`${this.baseUrl}/loadReplacementHistory?schemaName=${schemaName}&tableName=${tableName}&entityId=${entityId}`);
    }

    loadReplacementDetails(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/loadReplacementDetails?id=${id}`);
    }

    checkReferences(schemaName, tableName, entityId, top, onlyWithDependecies) {
        return this.$http.get(`${this.baseUrl}/checkReferences?schemaName=${schemaName}&tableName=${tableName}&entityId=${entityId}&top=${top}&onlyWithDependecies=${onlyWithDependecies}`);
    }

    replaceReferences(model) {
        return this.$http.put(`${this.baseUrl}/replaceReferences`, model);
    }
}

export default new DataReferencesService();
